import { ISVGChartWidget } from '@/pages/Dashboards/dashboards.types.ts'
import { IComputedParameterDef, IParameter } from '@/pages/Parameters/parameters.types.ts'
import { CSSProperties, memo, useMemo } from 'react'
import SVGChart from '@/pages/Dashboards/Charts/SVGChart'
import svgUtils from '@/pages/Dashboards/Charts/SVGChart/svg.utils.ts'
import useLastValuesWithComputedRef from '@/services/data/hooks/useLastValuesWithComputedRef'

interface IProps {
  widget: ISVGChartWidget
  lastResize?: number

  // For local svg files
  svgFileSrcString?: string
  textParameterPreprocessFn?: (parameter: IParameter, value: string) => string
  computed?: IComputedParameterDef[]
  live?: boolean
  ts?: number
  wrapperStyle?: CSSProperties
}

/**
 * Компонент, отображающий svg-график вне дашборда
 * */
const StandaloneSvgChart = (props: IProps) => {
  const tsFrom = useMemo(() => new Date().getTime() - 60 * 1000, [])

  const dataConfig = useMemo(() => {
    return svgUtils.extractDevicesAndParameters(props.widget.configuration.settings)
  }, [
    props.widget.configuration.settings.text,
    props.widget.configuration.settings.color,
    props.widget.configuration.settings.visibility,
    props.widget.configuration.settings.movements,
    props.widget.configuration.settings.rotations,
  ])

  const lastValuesConfig = useMemo(() => {
    return {
      computed: props.computed ?? [],
      devices: dataConfig.devices,
      parameters: dataConfig.parameters,
      id: props.widget.id.toString(),
      tsFrom: props.live === false ? props.ts : tsFrom,
      live: props.live !== false,
    }
  }, [dataConfig, props.computed, props.live, props.ts, props.widget.id, tsFrom])

  const { ref: lastValuesDataRef } = useLastValuesWithComputedRef(lastValuesConfig)

  return <SVGChart {...props} dataRef={lastValuesDataRef} />
}

export default memo(StandaloneSvgChart)
